var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3873 1.3902C25.3873 0.837913 24.9396 0.390198 24.3873 0.390198H1.61292C1.06064 0.390198 0.612925 0.837913 0.612925 1.3902C0.612925 1.94248 1.06064 2.3902 1.61292 2.3902H24.3873C24.9396 2.3902 25.3873 1.94248 25.3873 1.3902ZM16.8469 10.0888C16.8469 9.53652 16.3992 9.08881 15.8469 9.08881H1.61304C1.06075 9.08881 0.613037 9.53652 0.613037 10.0888C0.613037 10.6411 1.06075 11.0888 1.61304 11.0888H15.8469C16.3992 11.0888 16.8469 10.6411 16.8469 10.0888ZM7.30618 17.7874C7.85847 17.7874 8.30618 18.2351 8.30618 18.7874C8.30618 19.3397 7.85847 19.7874 7.30618 19.7874H1.61279C1.06051 19.7874 0.612793 19.3397 0.612793 18.7874C0.612793 18.2351 1.06051 17.7874 1.61279 17.7874H7.30618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.bf3e99b48f2f41eeae7a09fdf8f2eabf.svg";
export { ForwardRef as ReactComponent };